import {
  FormulaVersionQueryValue,
  SortByTypeQueryValue,
  SortOrderQueryValue,
  FlavorSKUValue
} from '@portal/types/review';
import { useCallback } from 'react';
import { useMutationUpdateV53WrittenReviews } from '@portal/state/atlas/updateV53WrittenReviews';
import { escapeHTMLEntities } from '@portal/shared/utils/format/escapeHTMLEntities';
import { WRITTEN_REVIEW_PAGINATION_LIMIT } from '../V53WrittenReviews/constants';

interface Parameters {
  filteredBy?: FormulaVersionQueryValue;
  sortBy?: SortByTypeQueryValue;
  sortOrder?: SortOrderQueryValue;
  sku?: FlavorSKUValue | string;
  page?: number;
  keyword?: string;
  rating?: number | string;
}

// helper function that interacts with the API hook
export const useGetLatestPaginatedReviews = () => {
  const updateReviewsData = useMutationUpdateV53WrittenReviews();

  const getLatestPaginatedReviews = useCallback(
    async ({
      parameters: { page, sortBy, sortOrder, filteredBy, keyword, sku, rating },
      onSuccess,
      onError
    }: {
      parameters: Parameters;
      onSuccess?: () => void;
      onError?: () => void;
    }) => {
      const response = await updateReviewsData.mutateAsync({
        queries: {
          page: page || 1,
          pageSize: WRITTEN_REVIEW_PAGINATION_LIMIT,
          sortBy: sortBy || 'rating',
          ...(sortOrder && { sortOrder }),
          ...(filteredBy && { formulaVersion: filteredBy }),
          ...(keyword && { keyword: escapeHTMLEntities(keyword) }),
          ...(sku && { sku }),
          ...(rating && { rating })
        },
        onComplete: () => {
          onSuccess?.();
        },
        onFail: () => {
          onError?.();
        }
      });
      return response;
    },
    [updateReviewsData]
  );

  return getLatestPaginatedReviews;
};
